import axios, { AxiosError } from 'axios';
import { getToken } from '../utils/token';
import { DeleteOwnerFieldResult, GetComplexFieldsResult } from '../types/fields';
import { Field } from '../types';

type DeleteOwnerFieldResultWithError = {
  data?: DeleteOwnerFieldResult;
  error?: any;
};

type GetFieldResultWithError = {
  data: Field | null;
  error: any;
};

type GetComplexFieldsResultWithError = {
  data: GetComplexFieldsResult | null;
  error: any;
};

export const getField = async (
  complexId: number,
  id: number,
  excludeExpired: boolean = false
) => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/owner/complexes/${complexId}/fields/${id}`;

  let result: GetFieldResultWithError = {
    data: null,
    error: null,
  };

  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
      params: {
        excludeExpired,
      },
    });

    result.data = response.data as Field;
  } catch (error) {
    const { response } = error as AxiosError;
    console.error('Error deleting field:', error);
    result.error = response?.data;
  }

  return result;
};

export const getFields = async (
  complexId: number,
  page: number,
  limit: number,
) => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/owner/complexes/${complexId}/fields?page=${page}&limit=${limit}`;

  let result: GetComplexFieldsResultWithError = {
    data: null,
    error: null,
  };

  try {
    const response = await axios.get(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    result.data = response.data as GetComplexFieldsResult;
  } catch (error) {
    const { response } = error as AxiosError;
    console.error('Error deleting field:', error);
    result.error = response?.data;
  }

  return result;
};

export const deleteField = async (complexId: number, id: number) => {
  const url = `${process.env.REACT_APP_API_ENDPOINT}/owner/complexes/${complexId}/fields/${id}`;

  let result: DeleteOwnerFieldResultWithError = {};

  try {
    const response = await axios.delete(url, {
      headers: { Authorization: `Bearer ${getToken()}` },
    });

    result.data = response.data as DeleteOwnerFieldResult;
  } catch (error) {
    const { response } = error as AxiosError;
    console.error('Error deleting field:', error);
    result.error = response?.data;
  }

  return result;
};
